import React from 'react';
import Layout from '../components/layout/Layout';

const RefundPolicyPage = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-[#0A0F1C] py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-white mb-8">Refund & Cancellation Policy</h1>
          
          <div className="prose prose-invert max-w-none text-gray-300 space-y-6">
            <p className="text-gray-400">Last updated: February 2025</p>
            
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Overview</h2>
              <p>
                This refund and cancellation policy outlines how you can cancel or seek a refund for a product/service that you have purchased through the Platform. Under this policy:
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Cancellation Policy</h2>
              <ul className="list-disc list-inside space-y-3 ml-4">
                <li>
                  Cancellations will only be considered if the request is made within <strong className="text-amber-400">5 days</strong> of placing the order.
                </li>
                <li>
                  However, cancellation requests may not be entertained if the orders have been communicated to such sellers/merchant(s) listed on the Platform and they have initiated the process of delivering them, or the product/service is already delivered/activated.
                </li>
                <li>
                  Credence Tax Advisors OPC Private Limited does not accept cancellation requests for digital services that have already been activated or accessed.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Refund Policy</h2>
              <ul className="list-disc list-inside space-y-3 ml-4">
                <li>
                  In case you feel that the product/service received is not as shown on the site or as per your expectations, you must bring it to the notice of our customer service within <strong className="text-amber-400">5 days</strong> of receiving the product/service.
                </li>
                <li>
                  The customer service team after looking into your complaint will take an appropriate decision.
                </li>
                <li>
                  In case of any refunds approved by Credence Tax Advisors OPC Private Limited, it will take <strong className="text-emerald-400">7 days</strong> for the refund to be processed to you.
                </li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Shipping Policy</h2>
              <div className="bg-blue-500/10 border border-blue-500/20 p-4 rounded-lg">
                <p className="text-blue-300 font-medium">
                  <strong>Not Applicable</strong> - PractiQ is a digital service platform. There are no physical products to be shipped. All services are delivered digitally through the platform.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Return Policy</h2>
              <div className="bg-blue-500/10 border border-blue-500/20 p-4 rounded-lg">
                <p className="text-blue-300 font-medium">
                  <strong>Not Applicable</strong> - As PractiQ is a digital service platform providing online tax filing simulation and training, there are no physical products to return. For any service-related concerns, please contact our customer support.
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-white mb-4">Contact for Refunds</h2>
              <div className="bg-white/5 border border-white/10 p-4 rounded-lg">
                <p className="mb-2">
                  <strong className="text-white">Email:</strong> 
                  <a href="mailto:support@taxsetu.ai" className="text-teal-400 ml-2">support@taxsetu.ai</a>
                </p>
                <p>
                  <strong className="text-white">Response Time:</strong> 
                  <span className="text-gray-400 ml-2">Within 24-48 hours</span>
                </p>
              </div>
            </section>

            <section className="mt-8 pt-6 border-t border-white/10">
              <p className="text-sm text-gray-500">
                <strong className="text-white">Company:</strong> Credence Tax Advisors OPC Private Limited
              </p>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RefundPolicyPage;
